import { useMemo, MutableRefObject } from 'react'
import { convertFileSizeWithUnit, handleFileName } from './Utils'
import cx from 'classnames'
import { Maybe } from 'types'
import { ReactComponent as FileIcon } from 'assets/icons/attachment.svg'
import Styles from './File.module.scss'

export const AttachedFile = ({
  meta,
  title,
  url,
  fileCardRef,
}: {
  meta: string
  title: string
  url: string
  fileCardRef: MutableRefObject<Maybe<HTMLDivElement>>
}) => {
  const size = useMemo(() => {
    try {
      const parsedMeta = JSON.parse(meta)
      if (parsedMeta && parsedMeta.size) return convertFileSizeWithUnit(parsedMeta.size, 2)
    } catch {}
  }, [meta])

  return (
    <div ref={fileCardRef} className={cx(Styles.fileCard, Styles.nonEmptyFileCard)}>
      <div className={Styles.left}>
        <div>
          <FileIcon className={Styles.fileIcon} />
        </div>
        <div>
          <span className={cx(Styles.fileName, Styles.fileCardTitle)}>{handleFileName(title)}</span>
        </div>
      </div>

      <div className={cx(Styles.right, Styles.hideWithoutHover)}>
        <div className={Styles.fileSizeLimit}>{size}</div>
        <div className={cx(Styles.fileCTA, Styles.downloadButton)}>
          <a href={url} download aria-label={`Download ${title}`}>
            Download
          </a>
        </div>
      </div>
    </div>
  )
}
